<p mat-dialog-title>
  {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.TITLE' | translate }}
</p>

<mat-dialog-content class="feedback-form-modal">
  <p>{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.INSTRUCTIONS' | translate }}</p>

  <div class="controls row">
    <glxy-form-field>
      <mat-checkbox [formControl]="formGroup.controls['inaccurateSummary']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.INACCURATE_SUMMARY' | translate }}
      </mat-checkbox>

      <mat-checkbox [formControl]="formGroup.controls['inaccurateTakeaways']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.INACCURATE_TAKEAWAYS' | translate }}
      </mat-checkbox>

      <mat-checkbox [formControl]="formGroup.controls['inaccurateActionItems']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.INACCURATE_ACTION_ITEMS' | translate }}
      </mat-checkbox>

      <mat-checkbox [formControl]="formGroup.controls['lackOfDetails']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.LACK_OF_DETAILS' | translate }}
      </mat-checkbox>
      <mat-checkbox [formControl]="formGroup.controls['wrongSpeakers']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.WRONG_SPEAKERS' | translate }}
      </mat-checkbox>

      <mat-checkbox [formControl]="formGroup.controls['other']">
        {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.OTHER' | translate }}
      </mat-checkbox>
    </glxy-form-field>
  </div>

  <glxy-form-field>
    <textarea
      matInput
      #feedbackCommentCounter
      maxlength="300"
      placeholder="{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.ADDITIONAL_INFO' | translate }}"
      [formControl]="formGroup.controls['comment']"
    ></textarea>
    <glxy-hint align="right">{{ feedbackCommentCounter.value?.length || 0 }}/300</glxy-hint>
  </glxy-form-field>
</mat-dialog-content>

<mat-dialog-actions class="actions-right">
  <button mat-stroked-button (click)="dialogRef.close()">
    {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.FEEDBACK_CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="submitFeedback()">
    {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.FEEDBACK.SEND_FEEDBACK' | translate }}
  </button>
</mat-dialog-actions>
